export default "__VITE_ASSET__DVzSuGT3__"